module.exports = {
  ...require("./topic"),
}
